// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__T8kA6","author":"Table_author__1etlR","authorImage":"Table_authorImage__21-ui","unreadRow":"Table_unreadRow__35MFZ"};